import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';

////admin pages import
import AdminLogin from './admin/pages/AdminLogin'
import AdminNavbar from './admin/components/AdminNavbar'
import AdminDashboard from './admin/pages/AdminDashboard'
import Addcar from './admin/pages/Addcar'
import ShowCars from './admin/pages/ShowCars'
import AddAdmin from './admin/pages/AddAdmin'
import AddBrands from './admin/pages/AddBrands';
import AddCategories from './admin/pages/AddCategories';

////frontend pages import
import Home from "./pages/Home"
import UserLogin from './pages/UserLogin';
import Comparison from './pages/Comparison';
import ComparisonDetails from './pages/ComparisonDetails';
import EmiCalculator from './pages/EmiCalculator';
import About from './pages/About';
import Error from './pages/Error';
import Cars from './pages/Cars';
import Category from './pages/Category';
import GetDetils from './pages/GetDetils';

//components import

import Footer from './components/Footer';
import Navbar from './components/Navbar';




function App() {

  return (
    <div className="App">

    <BrowserRouter>

    {/* user Routing */}
      <Routes>
        <Route path ="/" element={<Navbar/>}> 
        <Route index element={<Home/>}/>
        <Route path ="/cars" element={<Cars/>}/>
        <Route path ="cars/:carID" element={<GetDetils/>}/>
        <Route path ="/category" element={<Category/>}/>
        <Route path ="/userlogin" element={<UserLogin/>}/>
        <Route path ="/Comparison" element={<Comparison/>}/>
        <Route path ="/Comparison/:carID1?/:carID2" element={<ComparisonDetails/>}/>
        <Route path ="/calculator" element={<EmiCalculator/>}/>
        <Route path ="/Aboutus" element={<About/>}/>
        </Route>

        <Route path='/adminlogin' element={<AdminLogin/>}/>

        {/* Admin Routing */}
        <Route path ="/admin" element={<AdminNavbar/>}>
        <Route index element={<AdminDashboard/>}/>
        <Route path='/admin/addcar' element={<Addcar/>}/>
        <Route path='/admin/showcars' element={<ShowCars/>}/>
        <Route path='/admin/AddAdmin' element={<AddAdmin/>}/>
        <Route path='/admin/AddBrand' element={<AddBrands/>}/>
        <Route path='/admin/AddCategories' element={<AddCategories/>}/>
        </Route>
        
        {/* ///error page */}
        <Route path='*' element={<Error/>}/>

      </Routes>
      <Footer/>
    </BrowserRouter> 

    
    {/* <GetDetils/> */}

    </div>
  );
}

export default App;
